import { IViewAcceleration } from '~src/dataAcceleration/types/IViewAcceleration';
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IRecent } from '~src/recents/types/IRecent';
import { IViewUsageInfo } from '~src/spacesPlatform/models/IUsageInfo';
import { INamedItem, ITypedItem } from '~src/spacesPlatform/models/resourceParts';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';
import { IWorkbookParent } from '~src/workbook/ServerApi/types/IWorkbook';

import { IView } from '../types/IView';

export interface IGetViewsParams extends IGetItemsParams {
}

export interface IGetViewsResult extends IGetItemsResult {
  views?: IView[];
  workbooks?: IWorkbookParent[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  maxStats?: IViewUsageInfo;
  favorites?: string[];
  recents?: IRecent[];
  viewAccelerations?: IViewAcceleration[];
}

export class GetViewsRequest extends Request<IGetViewsParams, IGetViewsResult> {
  constructor(params: IGetViewsParams) {
    super('getViews', params);
  }
}
